import { useQuery } from '@tanstack/react-query'
import { getCapabilities } from '../../../types'
import { actionApiCall } from '../api/actionApiCall'

/**
 * Volitelné funkce instalace (OCR, AI, překlad). Klient podle nich nenabízí
 * tlačítka pro to, co na serveru není nakonfigurované.
 */
export function useCapabilities() {
    return useQuery({
        queryKey: ['capabilities'],
        queryFn: () => actionApiCall(() => getCapabilities(), { silent: true }),
        staleTime: 60 * 60 * 1000,
    })
}
